/* The dev cat-switcher panel: second in the left stack, hidden until the
   debug overlay reveals it (debug.js holds the handle). */
#hud{padding:13px 16px;display:flex;flex-direction:column;gap:11px;min-width:212px}
#cat-name{font-family:"Archivo",system-ui,sans-serif;font-weight:800;font-size:1.06rem;
  letter-spacing:-.02em;line-height:1.15}
@media (max-width:640px){
  #hud{min-width:0}
}
